import { render, staticRenderFns } from "./GLTFViewer.vue?vue&type=template&id=659996ce"
import script from "./GLTFViewer.vue?vue&type=script&lang=js"
export * from "./GLTFViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports